const BC_MAIL = '@bettercollective.com';
const MAIL_REGEX = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

class ValidateHelper {
  public static isBCMail(mail: string): boolean {
    return mail.endsWith(BC_MAIL);
  }

  public static isMail(mail: string): boolean {
    return MAIL_REGEX.test(mail);
  }
}

export default ValidateHelper;
